import React from "react";
import { Modal, List, Typography } from "antd";
import SbButton from "uiCore/SbButton/SbButton";
import { TEXT, SCALE_DETAILS_MODAL_WIDTH } from "../../EmployeeSkillsBridgerV2.constants";
import { BUTTON_TYPE_PRIMARY } from "constants/ui.constants";
import {
  ScaleModalTitleStyled,
  ScaleInfoIconStyled,
  ScaleAvatarStyled,
  SCALE_DETAILS_MODAL_STYLES,
} from "./ScaleDetailsModal.styles";

const ScaleDetailsModal = ({ open, scaleData, onClose }) => (
  <Modal
    title={
      <ScaleModalTitleStyled>
        <ScaleInfoIconStyled />
        {TEXT.SCALE_HEADING}
      </ScaleModalTitleStyled>
    }
    open={open}
    onCancel={onClose}
    footer={
      <SbButton buttonType={BUTTON_TYPE_PRIMARY} onClick={onClose}>
        {TEXT.BTN_HIDE_DETAILS}
      </SbButton>
    }
    width={SCALE_DETAILS_MODAL_WIDTH}
    styles={SCALE_DETAILS_MODAL_STYLES}
  >
    <List
      dataSource={scaleData?.proficiency_scale ?? []}
      renderItem={(item, i) => (
        <List.Item>
          <List.Item.Meta
            avatar={<ScaleAvatarStyled>{i}</ScaleAvatarStyled>}
            title={<Typography.Text strong>{item.name}</Typography.Text>}
            description={item.description}
          />
        </List.Item>
      )}
    />
  </Modal>
);

export default ScaleDetailsModal;
